import PropTypes from "prop-types";

import { Grid, makeStyles } from "../../utils/barrels/material-ui-core";

const styles = {
	grid: {
		padding: "0 15px !important",
	},
};

const useStyles = makeStyles(styles);

export default function GridItem(props) {
	const classes = useStyles();
	const { children, className, ...rest } = props;
	return (
		<Grid item {...rest} className={`${classes.grid} ${className}`}>
			{children}
		</Grid>
	);
}

GridItem.propTypes = {
	className: PropTypes.string,
	children: PropTypes.node,
};
